import { ReactNode, useRef, useState } from 'react';
import { Close } from '@styled-icons/remix-line';

import theme from 'styles/theme';
import PlayButton from '../PlayButton';

import * as S from './styles';

export type VideoModalProps = {
  open: boolean;
  videoLink: string;
  videoType: 'youtube' | 'vimeo';
  backgroundImage: string;
  text?: string;
  title: ReactNode | string;
  closeModal: () => void;
  startAt?: number;
};

const VideoModal = ({
  open,
  videoLink,
  videoType,
  backgroundImage,
  title,
  text,
  closeModal,
  startAt = 0,
}: VideoModalProps) => {
  const [startVideo, setStartVideo] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const stopVideo = () => {
    if (videoType === 'youtube') {
      iframeRef?.current?.contentWindow?.postMessage(
        '{"event":"command","func":"' + 'stopVideo' + '","args":""}',
        '*'
      );
    } else if (videoType === 'vimeo') {
      iframeRef?.current?.contentWindow?.postMessage('{"method":"pause"}', '*');
    }
  };

  const onCancel = () => {
    stopVideo();
    setStartVideo(false);
    closeModal();
  };

  const getVideoSrc = () => {
    if (videoType === 'youtube') {
      return `${videoLink}?autoplay=1&start=${startAt}&enablejsapi=1`;
    } else if (videoType === 'vimeo') {
      return `${videoLink}&autoplay=1`;
    }
  };

  return (
    <S.Modal
      centered
      videoActive={startVideo}
      backgroundImage={backgroundImage}
      open={open}
      width={860}
      footer={null}
      onCancel={onCancel}
      closeIcon={
        <S.CloseButton>
          <Close size={18} color={theme.colors.neutralSilver50} />
        </S.CloseButton>
      }
    >
      {startVideo ? (
        <S.IFrame>
          <iframe
            ref={iframeRef}
            width="560"
            height="315"
            src={getVideoSrc()}
            title="Video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </S.IFrame>
      ) : (
        <S.Content>
          <S.TextContainer>
            <p>{title}</p>
            {text && <span>{text}</span>}
          </S.TextContainer>
          <S.PlayButtonContainer>
            <PlayButton
              variant="secondary"
              size="large"
              onClick={() => setStartVideo(true)}
            />
          </S.PlayButtonContainer>
        </S.Content>
      )}
    </S.Modal>
  );
};

export default VideoModal;
